// @ts-nocheck
import axios from 'axios';
import { create } from 'zustand';
import { API_URL } from '../../configs';
import { toastTypes } from '../../enums';
import getRoot from '../root';
import useFormsStore from '../forms';

const useOMI366Store = create((set, get) => ({
  configs: { appKey: '', appSecret: '', enabled: true },
  assignedDripCampaigns: {},
  availableDripCampaigns: {},
  loading: false,

  reset: () => set({
    configs: {}, assignedDripCampaigns: {}, availableDripCampaigns: {}, loading: false,
  }),

  setConfigField: (name, value) => set((s) => ({ configs: { ...s.configs, [name]: value } })),

  getConfigs: async () => {
    try {
      set({ loading: true });
      const { data } = await axios.get(`${API_URL}/api/integrations/OMI366/config`);
      if (data.success) set((s) => ({ configs: { ...s.configs, ...data.config } }));
    } catch (e) { /* ignore */ } finally {
      set({ loading: false });
    }
  },

  updateConfigs: async () => {
    const root = getRoot();
    try {
      set({ loading: true });
      const { data } = await axios.post(`${API_URL}/api/integrations/OMI366/config`, { ...get().configs });
      if (data.success) {
        root.success('Successfully updated the configurations.', toastTypes.omiUpdateConfigs);
        root.clearToast(toastTypes.omiUpdateConfigs);
      } else throw new Error();
    } catch (e) {
      root.failure('Something went wrong...', toastTypes.omiUpdateConfigs);
    } finally {
      get().getConfigs();
      set({ loading: false });
    }
  },

  getDripCampaigns: async () => {
    try {
      set({ loading: true });
      const { data } = await axios.get(`${API_URL}/api/integrations/OMI366/drip-campaigns`);
      if (data.success) {
        const { dripCampaigns } = data;
        const obj = {};
        for (let i = 0; i < dripCampaigns.length; i += 1) {
          obj[dripCampaigns[i].campaign_Id] = dripCampaigns[i];
        }
        set({ availableDripCampaigns: obj });
      }
    } catch (e) { /* ignore */ } finally {
      set({ loading: false });
    }
  },

  updateDripCampaigns: async (hostname, path, dripCampaignIds) => {
    const root = getRoot();
    try {
      set({ loading: true });
      const { data } = await axios.post(`${API_URL}/api/integrations/OMI366/assign-form-to-drip-campaign`, {
        hostname, path, dripCampaignIds,
      });
      if (data.success) root.success('Successfully updated 366 Drip Campaign settings.');
      else throw new Error();
    } catch (e) { /* ignore */ } finally {
      set((s) => {
        const assigned = { ...s.assignedDripCampaigns };
        assigned[hostname] = assigned[hostname] || {};
        assigned[hostname][path] = { ...(assigned[hostname][path] || {}), campaignIds: [] };
        return { assignedDripCampaigns: assigned };
      });
      await useFormsStore.getState().getFormLinks();
      set({ loading: false });
    }
  },
}));

export default useOMI366Store;
